import React, { useState } from "react";
import { CreatePaymentMethod } from "../../pages";
import { TransactionsController } from "../../controllers";
import constant from "../../utils/constant";
import { MimaToastUtil } from "../../components";
import * as yup from "yup";

const CreatePaymentMethodContainer = ({ closeModal }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object().shape({
    currencyCode: yup.string().required("Currency is required"),
    countryCode: yup.string().required("Country is required"),
    methods: yup
      .array()
      .of(
        yup.object().shape({
          name: yup.string().required("Method name is required"),
          requiredFields: yup
            .array()
            .of(yup.string().required("Field is required"))
            .min(1, "At least one required field must be added"),
        })
      )
      .min(1, "At least one payment method is required"),
  });

  const onSubmit = async (values) => {
    setLoading(true);
    const payload = {
      methods: values.methods,
      countryCode: values.countryCode,
      currencyCode: values.currencyCode,
    };
    const { status, errorMessage } =
      await TransactionsController.createPaymentMethod(payload);
    if (status === constant.Success) {
      closeModal();
      setLoading(false);
      MimaToastUtil.success({
        message: constant.Success,
      });
    }
    setLoading(false);

    return closeModal();
  };

  const currencyCodes = [
    {
      key: "NGN",
      value: "NGN",
    },
    {
      key: "USD",
      value: "USD",
    },
    {
      key: "GBP",
      value: "GBP",
    },
    {
      key: "EUR",
      value: "EUR",
    },
  ];
  return (
    <CreatePaymentMethod
      closeModal={closeModal}
      currencyCodes={currencyCodes}
      onSubmit={onSubmit}
      loading={loading}
      validationSchema={validationSchema}
    />
  );
};

export default CreatePaymentMethodContainer;
